// extracted by mini-css-extract-plugin
export default {"giveVoiceWrapper":"giveVoice_giveVoiceWrapper__Vz39t"};